// extracted by mini-css-extract-plugin
export default {"dateElement":"yFKbgaN84b3DYCUrrx8z","todayElement":"X6g0AWhJsic87q3MhyrQ"};